import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import * as R from 'remeda';
import { forecastActions as aggregatedForecastActions } from 'store/aggregated/forecast';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Persists a single user forecast (Data.Projection) via Prediction_Create and
// adds the server-assigned row to the aggregated forecast domain. toPrediction
// can return undefined when required fields are missing — guard before put.
export function* createForecast(args: {
  zoneId: string;
  date: Time.Day;
  value: number;
}) {
  function* work(tenantId: string) {
    const { projection }: SagaReturnType<typeof api.createForecast> =
      yield call(api.createForecast, { tenantId, ...args });

    if (!R.isDefined(projection)) return;

    yield put(aggregatedForecastActions.add(projection));
    return projection;
  }

  yield call(operationWrapper, work, JwtFeature.Forecast);
}
